'use strict';

var isTransitionEndSupported = require('../../../../_virtual/isTransitionEndSupported.js_commonjs-exports.js');

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isTransitionEndSupported;

function isTransitionEndSupported() {
  return !!(typeof window !== 'undefined' && 'TransitionEvent' in window);
}
}(isTransitionEndSupported.__exports));
